/* eslint-disable react-hooks/exhaustive-deps */
import BaseLayout from "../Layout/BaseLayout";
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import { useApi } from "../Context/ApiProvider";
import { useLocation, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Button, Card, Divider, Spinner } from "@nextui-org/react";
import PaginationBasic from "../Components/PaginationBasic";
import { Helmet } from "react-helmet";
import ImageBackground from "../Components/ImageBackground";

export default function ProductsPage() {
  const { t } = useTranslation();
  const api = useApi();
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const categoryId = queryParams.get("category");
  const productsRef = useRef(null);

  const [catItems, setCatItems] = useState([]);
  const [searchTerm] = useState("");
  const [, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedBrand] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loadingPage, setLoadingPage] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [seoData, setSeoData] = useState({
    seo_title: "",
    search_description: "",
  });

  useEffect(() => {
    if (categoryId) {
      const category = categories.find(
        (cat) => cat.id === parseInt(categoryId)
      );
      if (category) {
        setSelectedCategory(category);
      }
    }
  }, [categoryId]);

  useEffect(() => {
    if (categoryId) {
      const category = categories.find(
        (cat) => cat.id === parseInt(categoryId)
      );
      if (category) {
        setSelectedCategory(category);
      }
    }
  }, [categoryId, categories]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const query = {
          limit: 21,
          offset: (currentPage - 1) * 21,
        };

        if (selectedCategory) {
          query.category = selectedCategory.id;
        }

        if (selectedBrand) {
          query.brand = selectedBrand.id;
        }

        setLoadingPage(true);
        // Fetch products
        const resProducts = await api.uget("/api/shop/products", query);
        if (resProducts.ok && resProducts.body && resProducts.body.results) {
          setTotalCount(resProducts.body.count);
          const fetchedItems = resProducts.body.results.map((item) => ({
            id: item.id,
            name: item.title,
            image: item.featured_image ? item.featured_image.url : null,
            gallery: item.gallery,
            text: item.excerpt,
            brand: item.brand.title,
            category: item.category.title,
          }));
          setCatItems(fetchedItems);
          if (resProducts.body.results.length > 0) {
            const firstProduct = resProducts.body.results;
            setSeoData({
              seo_title: firstProduct.seo_title,
              search_description: firstProduct.search_description,
            });
          }
        }

        // Fetch brands
        const resBrands = await api.uget("/api/shop/brands?");
        if (resBrands.ok && resBrands.body && resBrands.body.results) {
          const fetchedBrands = resBrands.body.results.map((brand) => ({
            id: brand.id,
            topic: brand.title,
            image: brand.image ? brand.image.url : null,
          }));
          setBrands(fetchedBrands);
        }

        // Fetch categories
        const resCategories = await api.uget("/api/shop/categories?");
        if (
          resCategories.ok &&
          resCategories.body &&
          resCategories.body.results
        ) {
          const fetchedCategories = resCategories.body.results.map(
            (category) => ({
              id: category.id,
              topic: category.title,
              image: category.image ? category.image.url : null,
              seo_title: category.seo_title,
              search_description: category.search_description,
            })
          );
          setCategories(fetchedCategories);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoadingPage(false);
      }
    };

    fetchData();
  }, [api, currentPage]);

  useEffect(() => {
    window.addEventListener("onMouseOver", filteredItems);
    return () => {
      window.removeEventListener("onMouseOver", filteredItems);
    };
  }, []);

  const handlePageChange = (newPage) => {
    if (totalCount <= 10) {
      setCurrentPage(1);
    } else {
      setCurrentPage(newPage);
    }
  };

  const handleProductPage = (productId) => {
    const lng = localStorage.getItem("lng");
    const newPath = `/${lng}/product-detail/${productId}`;
    navigate(newPath);
  };

  const handleCategoryClick = async (category) => {
    setSelectedCategory(category);
    setCurrentPage(1);
    navigate(
      `/${localStorage.getItem("lng")}/products/?category=${category.id}`
    );
  };

  useEffect(() => {
    if (categoryId) {
      const category = categories.find(
        (cat) => cat.id === parseInt(categoryId)
      );
      if (category) {
        setSelectedCategory(category);
        const categorySeoData = categories.find(
          (cat) => cat.id === category.id
        );
        if (categorySeoData) {
          setSeoData({
            seo_title: categorySeoData.seo_title,
            search_description: categorySeoData.search_description,
          });
        }
        // Scroll to products section
        if (productsRef.current) {
          productsRef.current.scrollIntoView({ behavior: "smooth" });
        }
      }
    }
  }, [categoryId, categories]);

  const filteredItems = catItems.filter((item) => {
    const matchSearchTerm = item.name
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchBrand = selectedBrand
      ? item.brand === selectedBrand.topic
      : true;
    const matchCategory = selectedCategory
      ? item.category === selectedCategory.topic
      : true;

    return matchSearchTerm && matchBrand && matchCategory;
  });

  return (
    <BaseLayout>
      <Helmet>
        <title>
          {selectedCategory ? seoData.seo_title : t("menuproducts")}
        </title>
        <meta name="description" content={seoData.search_description} />
      </Helmet>
      <Swiper
        dir="rtl"
        className="h-[15rem] md:h-[20rem] lg:h-[25rem] xl:h-[35rem]   mt-16 "
      >
        <div className=" absolute top-[55%] lg:top-1/2 left-[70%] lg:left-[20%] transform -translate-x-1/2 -translate-y-1/4 z-10 space-x-4 flex flex-col lg:flex-row-reverse gap-3 items-center">
          <div className="leading-loose ">
            <h1 className="text-md lg:text-xl  2xl:text-3xl font-bold text-center -mb-2  text-slate-50 ">
              {t("categortlisttitle")}
            </h1>
            <Divider className="bg-red-600 h-1    my-2" />
            <div
              className={`bg-white px-5 py-2 rounded-md   flex justify-center items-center w-full whitespace-nowrap ${
                localStorage.getItem("lng") === "fa"
                  ? "rtl"
                  : localStorage.getItem("lng") === "en"
                  ? "ltr  flex-row-reverse lg:flex-row"
                  : ""
              }`}
            >
              <div
                className="text-sm text-gray-600 cursor-pointer "
                onClick={() => navigate("/")}
              >
                {t("menuHome")}
              </div>
              <span className="px-2">/</span>
              <div>
                <span className="text-[15px] font-bold ">
                  {t("categortlisttitle")}
                </span>
              </div>
            </div>
          </div>
        </div>
        <SwiperSlide key={1}>
          <img
            src={"/Assets/Images/banners/banner3.jpg"}
            className="w-full h-full lg:hidden  "
            alt="1"
          />
          <img
            src={"/Assets/Images/banner3.jpg"}
            className="w-full h-full  hidden lg:block"
            alt="1"
          />
        </SwiperSlide>
      </Swiper>

      <div className=" m-auto  ">
        <div className="   hover:cursor-pointer bg-gradient-to-l from-primary-800  from-20%  to-emerald-900 to-90%   rounded-none p-5 ">
          <div className="flex flex-col items-center justify-center">
            <h2 className=" text-white text-2xl xl:text-4xl mt-4 lg:mt-6 ">
              {t("categortlisttitle")}
            </h2>
            <Divider className=" w-40 h-1 bg-red-600 mx-auto mb-10  mt-2 xl:mt-5   " />
          </div>
          <Swiper
            dir="rtl"
            breakpoints={{
              320: { slidesPerView: 1, spaceBetween: 10 },
              480: { slidesPerView: 2, spaceBetween: 15 },
              768: { slidesPerView: 3, spaceBetween: 10 },
              1024: { slidesPerView: 4, spaceBetween: 15 },
            }}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            loop={true}
            modules={[Pagination, Autoplay]}
            pagination={{ dynamicBullets: true }}
            className="mySwiper product swiper-category "
          >
            {categories.map((category) => (
              <SwiperSlide key={category.id}>
                <div
                  onClick={() => handleCategoryClick(category)}
                  className={`flex flex-col items-center cursor-pointer transition-transform duration-200 xl:w-[90%] m-auto mb-10 border hover:scale-95 `}
                >
                  <img
                    src={category.image}
                    alt={category.topic}
                    className={` w-full h-52 lg:!h-72 ${
                      selectedCategory && selectedCategory.id === category.id
                        ? "border-4 border-primary "
                        : ""
                    }`}
                  />
                  <Button
                    size="md"
                    className="bg-white w-full text-black text-lg rounded-none hover:bg-primary "
                    onClick={() => handleCategoryClick(category)}
                  >
                    {category.topic}
                  </Button>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div
          ref={productsRef}
          className="grid  grid-cols-1 xl:w-[95%] 2xl:w-[80%] m-auto   items-center  "
        >
          <div className=" mt-3 md:mt-0 grid  ">
            {loadingPage ? (
              <Spinner size="lg" className="flex justify-center mt-16 mb-5 " />
            ) : (
              <div className="w-full h-auto grid gap-6 md:grid-cols-2 lg:grid-cols-3 mt-5 p-5">
                {filteredItems.map((item) => (
                  <Card className=" w-full !rounded-tr-md !rounded-tl-md rounded-none ">
                    <div className="h-full">
                      <ImageBackground>
                        <img
                          src={item.image || "/Assets/Images/images.png"}
                          alt={""}
                          className="absolute w-full h-52 object-contain cursor-pointer transition-all duration-300"
                          onMouseOver={(e) => {
                            const galleryImages = item.gallery.map(
                              (galleryItem) => galleryItem.image.url
                            );
                            // Check if the gallery is not empty
                            if (galleryImages.length > 0) {
                              const randomGalleryImage =
                                galleryImages[
                                  Math.floor(
                                    Math.random() * galleryImages.length
                                  )
                                ];
                              e.target.dataset.originalSrc = e.target.src;
                              e.target.src = randomGalleryImage;
                            }
                          }}
                          onMouseOut={(e) => {
                            if (e.target.dataset.originalSrc) {
                              e.target.src = e.target.dataset.originalSrc;
                            }
                          }}
                          onClick={() => handleProductPage(item.id)}
                        />
                      </ImageBackground>

                      <h1 className="text-center text-md  text-blue-950 lg:text-xl font-extrabold ">
                        {item.name}
                        <Divider className="mt-2 mb-2  " />
                      </h1>
                    </div>

                    <Button
                      variant="bordered"
                      onClick={() => handleProductPage(item.id)}
                      className="w-full bg-primary text-white hover:bg-white hover:text-black !rounded-none border-none  "
                    >
                      {t("ProductDetail")}
                    </Button>
                  </Card>
                ))}
              </div>
            )}
            {filteredItems.length > 0 && (
              <div className="flex justify-center mb-5">
                <PaginationBasic
                  currentPage={currentPage}
                  totalItems={totalCount}
                  itemsPerPage={21}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </BaseLayout>
  );
}
